import { render, staticRenderFns } from "./TextWithBtnToggle.vue?vue&type=template&id=0fe4ccc6&scoped=true&"
import script from "./TextWithBtnToggle.vue?vue&type=script&lang=js&"
export * from "./TextWithBtnToggle.vue?vue&type=script&lang=js&"
import style0 from "./TextWithBtnToggle.vue?vue&type=style&index=0&id=0fe4ccc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4ccc6",
  null
  
)

export default component.exports